import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        //justifyContent: 'space-between',
        borderBottomColor: '#000000',
        borderBottomWidth: 1,
        alignItems: 'center',
        fontSize: 9,
        //height: auto,
        fontStyle: 'bold',
        lineHeight: 1.05,
        alignContent: 'flex-start',
        border: 0,
        borderRightWidth: 1,
        borderLeftWidth: 1,
    },
    rowLast: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      //justifyContent: 'space-between',
      borderBottomColor: '#000000',
     // borderBottomWidth: 1,
     // borderBottom: 1,
     
      alignItems: 'center',
      fontSize: 9,
      //height: auto,
      fontStyle: 'bold',
      lineHeight: 1.05,
      alignContent: 'flex-start',
      border: 0,
      borderRightWidth: 1,
      borderLeftWidth: 1,
      borderBottom: 1
      
  },
  marg_100_cross: {
    width: '45%',
    
    textAlign: 'center',
    borderRightColor: borderColor,
    borderRightWidth: 0,
    paddingLeft: 8,
    fontStyle: 'bold',
    textDecoration: 'line-through',
    border:0
},
    marg_100: {
        width: '45%',
        
        textAlign: 'center',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        paddingLeft: 8,
        fontStyle: 'bold',
        border:0
    },
    marg_50: {
        width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        textAlign: 'center',
        paddingRight: 8,
        border:0
    }, 
    marg_100_2: {
      width: '45%',
      
      textAlign: 'center',
      borderRightColor: borderColor,
      borderRightWidth: 0,
      paddingLeft: 8,
      fontStyle: 'bold',
      border:0,
      fontSize:14,
      fontFamily:"Times-Roman",
      fontWeight: "bold"
  },
  marg_50_2: {
      width: '20%',
      borderRightColor: borderColor,
      borderRightWidth: 0,
      textAlign: 'center',
      paddingRight: 8,
      border:0,
      fontSize:14,
      fontFamily:"Times-Roman",
      fontWeight: "bold"
  }, 
    marg_33: {
        width: '33%',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        textAlign: 'center',
        fontSize:14,
        fontFamily:"Times-Roman",
        paddingRight: 0,
        fontWeight: "bold",
        border:0
    }, 
    marg_25: {
        width: '33%',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        textAlign: 'center',
        paddingRight: 0,
        border:0
    }, 
    
  });

  function styleDefine (indexP, indexM, crossOutText) {
    let marg = styles.marg_100;
    let index = 3;
    if(indexP == 0) {
      if(indexM  == 1) {
        index = 5;
      } else if(indexM  == 2) {
        index = 6;
      }
    } else {
      index = 4;
      if(indexM  == 1) {
        index = 1;
      } else if(indexM  == 2) {
        index = 2;
      }
  }
    switch(index) {
        case 1: marg = crossOutText ? styles.marg_100_cross: styles.marg_100; break;
        case 2: marg = styles.marg_50; break;
        case 3: marg = styles.marg_33; break;
        case 4: marg = styles.marg_25; break;
        case 5:marg = styles.marg_100_2; break;
        case 6: marg = styles.marg_50_2; break;
    }
 
   
    return marg;
  }

  function isCrossOut(crossOutText, indexP, index){

    if(index == 1 && crossOutText[indexP][index] === true){
      return true;
    }
    return false;
  }
const InvoiceTableRowBartey = ({items, crossOutText}) => {

     //console.log(items[0][0], items[0][1], items[0][2])
     //console.log("size items" + items.length);
    const rows = items.map( (item, indexP) =>  
        <View style={(indexP == (items.length -1) ) ? styles.rowLast : styles.row} key={indexP}>
        {item.map((element, index) => 
            <Text key={(index+1)*(indexP+1)} 
             style={styleDefine(indexP,index, isCrossOut(crossOutText, indexP, index))} >
            {element}
            </Text>
        )}
        
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};
  
export default InvoiceTableRowBartey